import { Block, BlockProps, useStyletron } from "@mezo-org/mezo-clay"

export default function TokensIcons({
  stackDirection = "forward",
  size,
  tokens,
}: {
  stackDirection?: "forward" | "reverse"
  size?: BlockProps["height"]
  tokens: { token: string; icon: string }[]
}) {
  const [css, theme] = useStyletron()

  return (
    <Block display="flex" flexWrap={false}>
      {tokens.map(({ token, icon }, index) => (
        <Block
          key={token}
          as="img"
          src={icon}
          alt={token}
          marginLeft={index > 0 ? "-12px" : 0}
          style={{
            position: "relative",
            zIndex:
              stackDirection === "reverse" ? tokens.length - index : index,
          }}
          backgroundColor={theme.colors.white}
          height={size ?? theme.sizing.scale800}
          width={size ?? theme.sizing.scale800}
          className={css({ borderRadius: "100%", objectFit: "cover" })}
        />
      ))}
    </Block>
  )
}
